import api from "@/lib/api";

const VID_KEY = "audrivio_vid";
const SAVED_KEY = "audrivio_contact_saved";
const EMAIL_RE = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;

// First-party anonymous visitor id: links cart events to a contact left later.
export function getVisitorId() {
  try {
    let v = localStorage.getItem(VID_KEY);
    if (!v) { v = `v_${Date.now().toString(36)}${Math.random().toString(36).slice(2, 10)}`; localStorage.setItem(VID_KEY, v); }
    return v;
  } catch { return null; }
}

export const isContactSaved = () => { try { return !!localStorage.getItem(SAVED_KEY); } catch { return false; } };

// Accepts a free-form contact ("mario@x.it" or "333 1234567"); returns null when invalid.
export function parseContact(raw) {
  const v = (raw || "").trim();
  if (EMAIL_RE.test(v)) return { email: v.toLowerCase(), phone: null };
  if (v.replace(/\D/g, "").length >= 8 && /^[+\d\s().-]+$/.test(v)) return { email: null, phone: v };
  return null;
}

export async function saveContact({ email = null, phone = null, name = null, items = [], subtotal = 0, source, lang = null }) {
  const fbp = (document.cookie.match(/(?:^|; )_fbp=([^;]+)/) || [])[1] || null;
  await api.post("/track/identify", {
    email, phone, name, fbp, visitor_id: getVisitorId(), source, lang,
    product_ids: items.map((i) => i.product_id), value: Number(Number(subtotal || 0).toFixed(2)), page_url: window.location.href,
  });
  try { localStorage.setItem(SAVED_KEY, new Date().toISOString()); } catch { /* ignore */ }
}
